// extracted by mini-css-extract-plugin
export default {"overlay":"Overlay_overlay__mpfM-","overlay__container":"Overlay_overlay__container__-DLSg"};